import {isEmpty} from "lodash";
import {createSelector} from "reselect";

const customFields = (state) => state.customFields;

export const customFieldsObj = createSelector(
  customFields,
  (data) => data.customFieldsData || {}
);

export const getCustomFieldsList = createSelector(
  customFieldsObj,
  (data) => data?.results || []
);

export const getCustomFieldsTotalCount = createSelector(
  customFieldsObj,
  (data) => data?.total_count
);

export const getCustomFieldsPaginationUrls = createSelector(customFieldsObj, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const customFieldChoicesObj = createSelector(
  customFields,
  (data) => data.customFieldChoicesData || {}
);

export const getCustomFieldChoicesList = createSelector(
  customFieldChoicesObj,
  (data) => data?.results || []
);

export const getCustomFieldChoicesTotalCount = createSelector(
  customFieldChoicesObj,
  (data) => data?.total_count
);

export const getCustomFieldChoicesPaginationUrls = createSelector(
  customFieldChoicesObj,
  (data) => ({
    prevUrl: data?.previous,
    nextUrl: data?.next,
  })
);

export const objectTypes = createSelector(customFields, (data) => {
  if (isEmpty(data.objectTypes)) {
    return [];
  }
  return data.objectTypes.map((item) => ({
    label: `${item.app_label} > ${item.model}`,
    value: item.id,
  }));
});

export const relatedObjectTypes = createSelector(customFields, (data) => {
  if (isEmpty(data.relatedObjectTypes)) {
    return [];
  }
  return data.relatedObjectTypes.map((item) => ({
    label: `${item.app_label} > ${item.model}`,
    value: item.id,
  }));
});

export const fieldTypes = createSelector(customFields, (data) => data.fieldTypes);

export const customFieldChoicesLabelValue = createSelector(customFields, (data) => {
  return data.customFieldChoicesLabelValue || [];
});
